import { Modal } from "antd";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import { ReactFlowProvider } from "reactflow";
import "reactflow/dist/style.css";

import FlowContent from "./graph/FlowContent";

export default function ProjectGraphModal({ project, onClose }) {
  if (!project) return null;

  return (
    <Modal
      title={
        <span>
          <DeploymentUnitOutlined
            style={{ color: "#a71e27", marginRight: 8 }}
          />
          Project Graph: {project.projectName}
        </span>
      }
      open={true}
      onCancel={onClose}
      footer={null}
      width="90vw"
      styles={{ body: { height: "70vh", padding: 0 } }}
    >
      <ReactFlowProvider>
        <FlowContent projectData={project} visible={true} />
      </ReactFlowProvider>
    </Modal>
  );
}
